import $ from 'jquery';

let progressInterval = null;
let previousActiveElement = null;

// Reset state
const loadedImages = [];
const countedIndices = new Set();

export default function initProduct360View() {
    const $container = $('.js-threesixty');
    const $loader = $('.js-threesixty-loader');
    const $progressBar = $('.js-threesixty-progress-bar');
    const $hint = $('.js-threesixty-hint');
    const canvas = document.querySelector('.js-threesixty-canvas');

    if (!$container.length || !canvas) return;

    // Reset indices
    countedIndices.clear();
    loadedImages.length = 0;

    const ctx = canvas.getContext('2d');
    if (progressInterval) clearInterval(progressInterval);

    const imageUrls = [];

    function collectSources() {
        const src = $(this).attr('data-src');
        if (src) imageUrls.push(src);
    }

    $('.js-threesixty-sources span').each(collectSources);

    const totalFrames = imageUrls.length;
    if (totalFrames === 0) return;

    let loadedImagesCount = 0;
    let isDragging = false;
    let startX = 0;
    let currentFrameIndex = 0;
    let startFrameIndex = 0;
    const pixelsPerFrame = 15;
    const startTime = Date.now();
    const minLoadingTime = 1200;

    // Reset UI State
    $loader.show().css({ opacity: '1', display: 'block' });
    $progressBar.css('width', '0%').attr('aria-valuenow', '0');
    $('.js-threesixty-images').removeClass('is--loaded');
    $hint.removeClass('is--visible is--hidden');

    function drawFrame(index) {
        const img = loadedImages[index];
        if (!img || img.naturalWidth === 0) return;

        const rect = canvas.getBoundingClientRect();
        const width = rect.width || 800;
        const height = rect.height || 800;

        ctx.clearRect(0, 0, width, height);

        const hRatio = width / img.naturalWidth;
        const vRatio = height / img.naturalHeight;
        const ratio = Math.max(hRatio, vRatio);
        const centerShiftX = (width - (img.naturalWidth * ratio)) / 2;
        const centerShiftY = (height - (img.naturalHeight * ratio)) / 2;

        ctx.drawImage(
            img,
            0,
            0,
            img.naturalWidth,
            img.naturalHeight,
            centerShiftX,
            centerShiftY,
            img.naturalWidth * ratio,
            img.naturalHeight * ratio,
        );
    }

    function resizeCanvas() {
        const rect = canvas.getBoundingClientRect();
        const width = rect.width || 800;
        const height = rect.height || 800;

        const dpr = window.devicePixelRatio || 1;
        canvas.width = width * dpr;
        canvas.height = height * dpr;

        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.scale(dpr, dpr);

        drawFrame(currentFrameIndex);
    }

    function registerImageLoaded(idx, img) {
        if (countedIndices.has(idx)) {
            return;
        }
        countedIndices.add(idx);

        if (img) {
            loadedImages[idx] = img;
        }

        loadedImagesCount += 1;

        if (idx === 0) {
            resizeCanvas();
        }
    }

    function processImagePreload(src, idx) {
        if (loadedImages[idx] && loadedImages[idx].complete) {
            registerImageLoaded(idx, loadedImages[idx]);
            return;
        }

        const img = new Image();
        let handled = false;

        const safariFallbackTimer = setTimeout(() => {
            if (!handled) {
                handled = true;
                registerImageLoaded(idx, img);
            }
        }, 3000);

        function handleLoad() {
            if (handled) return;
            handled = true;
            clearTimeout(safariFallbackTimer);
            registerImageLoaded(idx, img);
        }

        function handleError() {
            if (handled) return;
            handled = true;
            clearTimeout(safariFallbackTimer);
            registerImageLoaded(idx, null);
        }

        img.onload = handleLoad;
        img.onerror = handleError;
        img.src = src;

        if (img.complete && img.naturalWidth !== 0) {
            handleLoad();
        }
    }

    function preloadImages() {
        imageUrls.forEach(processImagePreload);
    }

    resizeCanvas();
    preloadImages();

    function handleMove(e) {
        if (!isDragging) return;
        if ($(e.target).closest('#threesixty-modal-content').length) {
            e.stopPropagation();
        }

        const pageX = e.pageX || (e.originalEvent.touches && e.originalEvent.touches[0].pageX);
        if (pageX === undefined) return;

        const deltaX = pageX - startX;
        const frameOffset = Math.floor(deltaX / pixelsPerFrame);
        const rawFrameIndex = startFrameIndex - frameOffset;
        const newFrameIndex = ((rawFrameIndex % totalFrames) + totalFrames) % totalFrames;

        if (newFrameIndex !== currentFrameIndex) {
            currentFrameIndex = newFrameIndex;
            drawFrame(currentFrameIndex);
        }
    }

    function handleRelease() {
        isDragging = false;
        $(window).off('.cpoviewer-move');
    }

    function handleDragStart(e) {
        isDragging = true;
        startX = e.pageX || (e.originalEvent.touches && e.originalEvent.touches[0].pageX);
        startFrameIndex = currentFrameIndex;

        if ($hint.length && !$hint.hasClass('is--hidden')) {
            $hint.addClass('is--hidden');
        }

        e.stopPropagation();
        $(window).on('mousemove.cpoviewer-move touchmove.cpoviewer-move', handleMove);
        $(window).on('mouseup.cpoviewer-move touchend.cpoviewer-move', handleRelease);
    }

    function handleKeyDown(e) {
        if (e.key === 'ArrowLeft' || e.key === 'a' || e.key === 'A') {
            e.preventDefault();
            currentFrameIndex = ((currentFrameIndex - 1) + totalFrames) % totalFrames;
            drawFrame(currentFrameIndex);
        } else if (e.key === 'ArrowRight' || e.key === 'd' || e.key === 'D') {
            e.preventDefault();
            currentFrameIndex = (currentFrameIndex + 1) % totalFrames;
            drawFrame(currentFrameIndex);
        }
    }

    function initDragEvents() {
        $container.off('mousedown touchstart keydown');
        $container.on('mousedown touchstart', handleDragStart);
        $container.on('keydown', handleKeyDown);
    }

    function onLoaderFadeOut() {
        $('.js-threesixty-images').addClass('is--loaded');
        if ($hint.length) $hint.addClass('is--visible');
        drawFrame(currentFrameIndex);
    }

    function revealViewer() {
        $loader.fadeOut(300, onLoaderFadeOut);
        resizeCanvas();
        initDragEvents();
    }

    function updateVisualProgress() {
        const timePassed = Date.now() - startTime;
        const timePercentage = (timePassed / minLoadingTime) * 100;
        const realDownloadPercentage = (loadedImagesCount / totalFrames) * 100;
        const visualProgress = Math.floor(Math.min(timePercentage, realDownloadPercentage));

        if ($progressBar.length) {
            $progressBar.css('width', `${visualProgress}%`).attr('aria-valuenow', visualProgress);
        }

        if (timePassed >= minLoadingTime && loadedImagesCount >= totalFrames) {
            clearInterval(progressInterval);
            $progressBar.css('width', '100%').attr('aria-valuenow', '100');
            setTimeout(revealViewer, 200);
        }
    }

    progressInterval = setInterval(updateVisualProgress, 30);
    $(window).off('.cpoviewer-resize').on('resize.cpoviewer-resize', resizeCanvas);

    window.destroyRolex360Viewer = function destroyRolex360Viewer() {
        clearInterval(progressInterval);
        isDragging = false;
        $(window).off('.cpoviewer-move');
        $(window).off('.cpoviewer-resize');
        $container.off('keydown');
    };
}

window.initProduct360View = initProduct360View;

window.performHardClose = function performHardClose() {
    if (typeof window.destroyRolex360Viewer === 'function') {
        window.destroyRolex360Viewer();
    }
    $(window).off('.cpoviewer-move .cpoviewer-key');

    const overlay = document.getElementById('threesixty-modal');
    if (overlay) {
        overlay.classList.add('is--hidden');
        overlay.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('is--lightbox-open');

    if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
        previousActiveElement.focus();
    }
};

function handleDelayedClose() {
    const $delayedCloseBtn = $('.js-rlx-v7-watch-gallery-lightbox__close');
    if ($delayedCloseBtn.length && $('.js-rlx-v7-watch-gallery-lightbox').is(':visible')) {
        $delayedCloseBtn.trigger('click');
    }
}

function handleDelayedInit() {
    if (typeof window.initProduct360View === 'function') {
        window.initProduct360View();
    }
}

function handleModalGlobalKeys(e) {
    if (e.key === 'Escape') {
        e.preventDefault();
        window.performHardClose();
        return;
    }

    if (e.key === 'Tab') {
        const modal = document.getElementById('threesixty-modal');
        if (!modal) return;

        const focusables = modal.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        );
        const firstFocusable = focusables[0];
        const lastFocusable = focusables[focusables.length - 1];

        if (e.shiftKey) {
            if (document.activeElement === firstFocusable) {
                e.preventDefault();
                lastFocusable.focus();
            }
        } else if (document.activeElement === lastFocusable) {
            e.preventDefault();
            firstFocusable.focus();
        }
    }
}

function focusCloseButton() {
    const $closeBtn = $('#threesixty-modal').find('.js-threesixty-close-btn');
    if ($closeBtn.length) {
        $closeBtn.focus();
    }
}

function handleOpenModal(e) {
    e.preventDefault();
    e.stopPropagation();

    previousActiveElement = document.activeElement;

    const $overlay = $('#threesixty-modal');

    if ($overlay.length) {
        $('.js-threesixty-images').removeClass('is--loaded');
        $('.js-threesixty-hint').removeClass('is--visible').addClass('is--hidden');
        $('.js-threesixty-loader').show().css({ opacity: '1', display: 'block' });
        $('.js-threesixty-progress-bar').css('width', '0%').attr('aria-valuenow', '0');

        $overlay.removeClass('is--hidden').attr('aria-hidden', 'false');
        $('body').addClass('is--lightbox-open');

        setTimeout(focusCloseButton, 50);

        $(window).off('.cpoviewer-key');
        $(window).on('keydown.cpoviewer-key', handleModalGlobalKeys);

        const $rolexCloseBtn = $('.js-rlx-v7-watch-gallery-lightbox__close');
        if ($rolexCloseBtn.length) {
            $rolexCloseBtn.trigger('click');
        }

        setTimeout(handleDelayedClose, 100);
        setTimeout(handleDelayedInit, 200);
    }
}

function handleBackgroundClose(e) {
    if (e.target === this) {
        window.performHardClose();
    }
}

function handleDocumentReady() {
    $('body').off('click', '.slider__navigation-360-view').on('click', '.slider__navigation-360-view', handleOpenModal);
    $(document).off('click', '.js-threesixty-close-btn').on('click', '.js-threesixty-close-btn', window.performHardClose);
    $(document).off('mousedown', '#threesixty-modal').on('mousedown', '#threesixty-modal', handleBackgroundClose);
}

$(document).ready(handleDocumentReady);
